import '@iotize/tap/service/impl/device';

import { Tap } from '@iotize/tap';
import { FirmwareState } from '@iotize/tap/service/impl/firmware';

declare module '@iotize/tap/lib/tap' {
  interface Tap {
    factoryReset(): Promise<void>;
  }
}

export async function factoryReset(this: Tap): Promise<void> {
  // check that IoTize FW is in Normal Mode
  const currentState = (await this.service.firmware.getState()).body();
  if (
    currentState !== FirmwareState.NORMAL &&
    currentState !== FirmwareState.LEGACY
  ) {
    throw new Error(
      'Cannot restore factory configuration during firmware update process.',
      // TODO proper error
    );
  }
  // ==================================================================
  // - Factory Reset ---------------------------------------------------
  (await this.service.device.factoryReset()).successful();
}

Tap.prototype.factoryReset = factoryReset;
